import axios from '../localAxios';
import { deleteAccountURL } from './url';

export async function deleteAccount({ password }: { password: string }) {
  const url = deleteAccountURL();
  const result = await axios.post(url.toString(), { password: password });
  return result.data;
}
